const isSuccess = (err) => {
  return Boolean(
    err && err.response && err.response.status >= 200 && err.response.status < 300
  )
}

export default isSuccess
